<template>
  <div class="cate-page-box">
    <seg-main>
      <template v-slot:back-word>
        <h1 class="page-introduce-word">
          我们能为你做什么
        </h1>
      </template>
      <div class="cate-menu-block-container">
        <cate-menu
          v-for="(m, k) of menu"
          :key="k"
          :cate-key="k"
          class="cate-menu-block"
          :list="m.children"
          to-route-name="GovernmentServiceDetail"
          :cover-pic="m.coverPic"
          style="width: calc(25% - 40px)"
          @click.native="$router.push({ path: m.url })"
        >
          <template v-slot:cate-title>
            {{ m.title }}
          </template>
          <template v-slot:cate-description>
            <div v-html="convertToHtmlList(m.description)" />
          </template>
        </cate-menu>
      </div>
    </seg-main>
    <!--    <bottom-partner />-->
  </div>
</template>

<script>
import CateMenu from '@/components/cate-menu-box/cate-menu';
import SegMain from '@/components/segPart/segMain';
import {menu} from '@/constant';

export default {
  name: 'CatePage',
  components: {
    SegMain, CateMenu
  },
  data() {
    return {
    }
  },
  computed: {
    menu: function () {
      return menu[3].children
    }
  },
  methods: {
    convertToHtmlList: function (val) {
      return val.split('、').map(i => `<div style="margin: 12px;">${i}</div>`).join('')
    }
  }
};
</script>

<style scoped lang="less">
  .cate-page-box {
    .page-introduce-word{
      font-size:32px;
      font-weight:500;
      color:rgba(213,213,213,1);
      text-align: center;
    }
  }

  .cate-menu-block-container{
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .cate-menu-block{
    width: 285px;
    float: left;
    cursor: pointer;
  }

</style>
